import React, { useState } from 'react';
import { Outlet, Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from './ui/button';
import { Sheet, SheetContent, SheetTrigger } from './ui/sheet';
import {
  LayoutDashboard,
  Users,
  FileEdit,
  Search,
  Brain,
  Code,
  Palette,
  Settings,
  Menu,
  LogOut
} from 'lucide-react';

const BackofficeLayout = () => {
  const { agent, logout } = useAuth();
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navItems = [
    { path: '/bo/dashboard', label: 'Dashboard', icon: LayoutDashboard },
    { path: '/bo/leads', label: 'Leads', icon: Users },
    { path: '/bo/page-editor', label: 'Éditeur de page', icon: FileEdit },
    { path: '/bo/seo', label: 'SEO Meta Tags', icon: Search },
    { path: '/bo/seo-llm', label: 'SEO + LLM Hacking', icon: Brain },
    { path: '/bo/tracking', label: 'Tracking', icon: Code },
    { path: '/bo/branding', label: 'Marque blanche', icon: Palette },
  ];

  const isActive = (path) => location.pathname === path;

  const NavContent = () => (
    <div className="flex flex-col h-full">
      <div className="p-6 border-b">
        <h2 className="text-xl font-semibold">Valeur Immo</h2>
        <p className="text-sm text-muted-foreground mt-1">
          {agent?.first_name} {agent?.last_name}
        </p>
        <p className="text-xs text-muted-foreground">{agent?.city}</p>
      </div>

      <nav className="flex-1 p-4 space-y-1">
        {navItems.map((item) => {
          const Icon = item.icon;
          return (
            <Link
              key={item.path}
              to={item.path}
              onClick={() => setMobileMenuOpen(false)}
              className={`flex items-center gap-3 px-3 py-2 rounded-md text-sm font-medium ${
                isActive(item.path)
                  ? 'bg-primary text-primary-foreground'
                  : 'text-muted-foreground hover:bg-muted hover:text-foreground'
              }`}
              data-testid={`nav-${item.label.toLowerCase().replace(/\s+/g, '-')}`}
            >
              <Icon className="w-5 h-5" />
              {item.label}
            </Link>
          );
        })}
      </nav>

      <div className="p-4 border-t">
        <Button
          variant="ghost"
          className="w-full justify-start"
          onClick={logout}
          data-testid="logout-button"
        >
          <LogOut className="w-5 h-5 mr-3" />
          Déconnexion
        </Button>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-background">
      {/* Mobile Header */}
      <header className="lg:hidden flex items-center justify-between p-4 border-b bg-card">
        <h1 className="text-lg font-semibold">Valeur Immo</h1>
        <Sheet open={mobileMenuOpen} onOpenChange={setMobileMenuOpen}>
          <SheetTrigger asChild>
            <Button variant="ghost" size="icon" data-testid="mobile-menu-button">
              <Menu className="w-6 h-6" />
            </Button>
          </SheetTrigger>
          <SheetContent side="left" className="p-0 w-64">
            <NavContent />
          </SheetContent>
        </Sheet>
      </header>

      <div className="lg:grid lg:grid-cols-[240px_1fr]">
        {/* Desktop Sidebar */}
        <aside className="hidden lg:block border-r bg-card h-screen sticky top-0">
          <NavContent />
        </aside>

        {/* Main Content */}
        <main className="p-6 lg:p-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default BackofficeLayout;
